import { useEffect, useState } from 'react'

import { InsightCardsPage } from './components/InsightCardsPage/Page'
import { RulesEngineDataProvider } from './context/RulesEngineDataProvider'
import { copy } from './Copy'
import { CustomInsight } from './types/CustomInsight'

import type { HttpClient, ApiInsight } from './types/ApiTypes'

interface RulesEngineProps {
  httpClient: HttpClient
}

export default function RulesEngine({ httpClient }: RulesEngineProps) {
  const [customInsights, setCustomInsights] = useState<CustomInsight[]>([])
  const [loading, setLoading] = useState(true)

  const fetchInsightCards = async () => {
    try {
      setLoading(true)
      // TODO Replace '/api/insights' with the actual endpoint for fetching insight cards
      const response = await httpClient.get<ApiInsight[]>('/api/insights')
      setCustomInsights(response)
    } catch (err) {
      console.error('Error fetching insight cards:', err)
      // If there's an error, we'll use empty array
      setCustomInsights([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchInsightCards()
  }, [])

  return (
    <RulesEngineDataProvider copy={copy} customInsights={customInsights}>
      {loading ? <div>{copy.loading_insights}</div> : <InsightCardsPage />}
    </RulesEngineDataProvider>
  )
}
